<div class="error-wrapper">
  <div class="error-card">
    <div class="icon">⚠️</div>

    <h1>Oops!</h1>
    <h2>Something went wrong</h2>

    <p>
      A system error has occurred. <br />
      Please contact the system administrator.
    </p>

    <div class="actions">
      <button class="primary-btn" (click)="retry()">Go Back</button>
    </div>
  </div>
</div>
